/**
 * Elandr shoes/socks quantity discount price updates.
 * - Reads percentOff from option attributes (Theme Editor settings)
 * - Uses event delegation so Theme Editor section reloads keep working
 * - Avoids currency-converter (.ccc) overwriting discounted prices
 */
;(function () {
  if (window.__elandrBundleQtyInit) return
  window.__elandrBundleQtyInit = true

  function priceParent() {
    return document.querySelector('.product_price_parent')
  }

  function priceEl(parent) {
    if (!parent) return null
    return (
      parent.querySelector('.price__regular .ccc.price-item--regular') ||
      parent.querySelector('.price__regular .price-item--regular') ||
      parent.querySelector('.price-item--sale.price-item--last')
    )
  }

  function formatMoney(cents, parent) {
    var currency =
      (parent && parent.getAttribute('data-currency')) ||
      (window.theme && window.theme.currency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'GBP'
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents, currency)
    }
    try {
      return new Intl.NumberFormat((window.theme && window.theme.locale) || undefined, {
        style: 'currency',
        currency: currency
      }).format(cents / 100)
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency
    }
  }

  function discountedLineCents(unitCents, qty, percentOff) {
    if (window.theme && typeof window.theme.discountedLineCents === 'function') {
      return window.theme.discountedLineCents(unitCents, qty, percentOff)
    }
    unitCents = Math.round(Number(unitCents) || 0)
    qty = Math.max(1, parseInt(qty, 10) || 1)
    percentOff = parseFloat(percentOff) || 0
    if (percentOff <= 0) return unitCents * qty
    var discountPerUnit = Math.floor((unitCents * percentOff) / 100)
    return (unitCents - discountPerUnit) * qty
  }

  function writePrice(parent, cents) {
    var el = priceEl(parent)
    if (!el) return
    var text = formatMoney(cents, parent)
    el.textContent = text
    // Prevent currency converter apps from reverting bundle math.
    el.classList.remove('ccc')
    el.setAttribute('data-elandr-bundle-price', String(cents))

    var saleEl = parent.querySelector('.price-item--sale.price-item--last')
    if (saleEl) {
      saleEl.textContent = text
      saleEl.classList.remove('ccc')
    }
  }

  function updateSaveUI(parent, percentOff) {
    var saveNote = parent.querySelector('[data-elandr-bundle-save-note]')
    var savePill = parent.querySelector('[data-elandr-bundle-save-pill]')
    var saleBadge = parent.querySelector('.price__badge-sale')

    if (saveNote) {
      if (percentOff > 0) {
        if (savePill) savePill.textContent = percentOff + '%'
        saveNote.hidden = false
        saveNote.removeAttribute('hidden')
      } else {
        saveNote.hidden = true
        saveNote.setAttribute('hidden', '')
      }
    }

    if (saleBadge) {
      if (percentOff > 0) {
        saleBadge.textContent = 'SAVE ' + percentOff + '%'
        saleBadge.style.display = ''
      } else {
        saleBadge.style.display = 'none'
      }
    }
  }

  function updateSocksProps(qty, percentOff) {
    var bundleProp = document.getElementById('socks-bundle-prop')
    var bundleSaveProp = document.getElementById('socks-bundle-save-prop')
    if (bundleProp) {
      if (qty > 1) {
        bundleProp.value = qty + ' pairs'
        bundleProp.disabled = false
      } else {
        bundleProp.value = ''
        bundleProp.disabled = true
      }
    }
    if (bundleSaveProp) {
      if (percentOff > 0) {
        bundleSaveProp.value = percentOff + '%'
        bundleSaveProp.disabled = false
      } else {
        bundleSaveProp.value = ''
        bundleSaveProp.disabled = true
      }
    }
  }

  function applyOption(opt, fromBoot) {
    if (!opt) return
    var parent = priceParent()
    if (!parent) return

    var qty = parseInt(opt.getAttribute('data-qty') || opt.dataset.qty, 10) || 1
    var percentOff = parseFloat(opt.getAttribute('percentoff')) || 0
    var basePriceCents = parseInt(parent.getAttribute('product__price'), 10)
    if (isNaN(basePriceCents)) return

    var pairQtyInput = document.getElementById('selected-pair-qty')
    var packQtyInput = document.getElementById('socks-pack-qty')
    if (opt.classList.contains('pair-option') && pairQtyInput) pairQtyInput.value = String(qty)
    if (opt.classList.contains('pack-option') && packQtyInput) {
      packQtyInput.value = String(qty)
      updateSocksProps(qty, percentOff)
    }

    var lineCents = discountedLineCents(basePriceCents, qty, percentOff)

    // Keep Liquid-rendered money on first paint for default 1-pair.
    if (!(fromBoot && qty === 1 && percentOff <= 0)) {
      writePrice(parent, lineCents)
      // Re-apply shortly after in case a converter/app mutates DOM.
      setTimeout(function () {
        writePrice(parent, lineCents)
      }, 50)
      setTimeout(function () {
        writePrice(parent, lineCents)
      }, 250)
    }

    updateSaveUI(parent, percentOff)
  }

  function activateOption(opt) {
    if (!opt) return
    var groupSelector = opt.classList.contains('pack-option') ? '.pack-option' : '.pair-option'
    document.querySelectorAll(groupSelector).forEach(function (item) {
      item.classList.remove('active')
    })
    opt.classList.add('active')
    applyOption(opt, false)
  }

  document.addEventListener(
    'click',
    function (event) {
      var pack = event.target.closest && event.target.closest('.pack-option')
      var pair = event.target.closest && event.target.closest('.pair-option')
      var opt = pack || pair
      if (!opt) return
      activateOption(opt)
    },
    true
  )

  function bootActive() {
    var active =
      document.querySelector('.pack-option.active') ||
      document.querySelector('.pair-option.active')
    if (active) applyOption(active, true)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootActive)
  } else {
    bootActive()
  }

  document.addEventListener('shopify:section:load', bootActive)
  document.addEventListener('shopify:section:reorder', bootActive)

  // Used by product-info.js after variant HTML price swap.
  window.elandrApplyActiveBundleQty = function () {
    var active =
      document.querySelector('.pack-option.active') ||
      document.querySelector('.pair-option.active')
    if (active) applyOption(active, false)
  }
})()
